import React from 'react';
import './BrandMark.css';

const defaultBrand = {
  brand_name: 'Forge',
  brand_subtitle: 'NYXN',
  logo_url: '/assets/foge_logo.png',
};

function BrandMark({ compact = false, brand = defaultBrand }) {
  const name = brand?.brand_name || defaultBrand.brand_name;
  const subtitle = brand?.brand_subtitle || defaultBrand.brand_subtitle;
  const logoUrl = brand?.logo_url || defaultBrand.logo_url;

  return (
    <div className={`brand-mark ${compact ? 'compact' : ''}`}>
      <img src={logoUrl} alt="" className="brand-mark-icon" />
      {!compact && (
        <div className="brand-mark-copy">
          <span className="brand-mark-name">{name}</span>
          <span className="brand-mark-sub">{subtitle}</span>
        </div>
      )}
    </div>
  );
}

export default BrandMark;
